import React, { useEffect, useState } from "react";
import { CALLCONTACT, MAILCONTACT } from "../../utils/aap-image-constant";
import { useTranslation } from "react-i18next";
import { getallContactUs } from "../../hooks/services/api-services";
import { API_RESPONSE } from "../../utils/app-constants";
import { toastEmitter } from "../../utils/utilities";

const Contactus = () => {
  const { t, i18n } = useTranslation();
  const [contactUs, setContactUs] = useState()
  const fetchContactData = async () => {
    try {
      const response = await getallContactUs();
      if (response.status !== 200) {
        toastEmitter("error", response?.data?.message);
      } else {
        setContactUs(response?.data?.data);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    }
  };
  useEffect(() => {
    fetchContactData();
  }, []);
  return (
    <div className="contactus_card my-4">

      <h2 className="mainheading fs-45 fw-600  text-start my-4">
        {t(`Contact`)}
        <span className="textcolor italic-text "> {t("Us")}</span>
      </h2>

      <div className="row align-items-center">

        <div className="col-12 col-lg-4 mb-4 mb-lg-0">
          <div className="border rounded-4 p-3 d-flex align-items-center contactus">
            <img
              src={MAILCONTACT}
              alt="img"
              className="img-fluid contactus-icon"
            />
            <div className={`ms-3 ${i18n.language === "ar" ? "me-3" : ""
              }`}>
              <h6 className="mb-1 fw-bold">{t("Email Us")}</h6>
              <p className="mb-0 text-muted  fs-14"> {contactUs && contactUs[0]?.email}</p>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-4  mb-4 mb-md-0">
          <div className="border rounded-4 p-3 d-flex align-items-center contactus">
            <img
              src={CALLCONTACT}
              alt="img"
              className="img-fluid contactus-icon"
            />
            <div className={`ms-3 ${i18n.language === "ar" ? "me-3" : ""
              }`}>
              <h6 className="mb-1 fw-bold">  {t("Call Us")}</h6>
              <p className="mb-0 text-muted fs-14">{contactUs && contactUs[0]?.mobileNo}</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-4 mb-4 mb-md-0">
          <div className="border rounded-4 p-3 d-flex align-items-center contactus">
            <img
              src={CALLCONTACT}
              alt="img"
              className="img-fluid contactus-icon"
            />
            <div className={`ms-3 ${i18n.language === "ar" ? "me-3" : ""
              }`}>
              <h6 className="mb-1 fw-bold">  {t("Address")}</h6>
              <p className="mb-0 text-muted fs-14">{contactUs && contactUs[0]?.address ||"ul. Daleka 8  02-020 Warszawa  Poland"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contactus;

